export default __webpack_public_path__ + "static/media/medaille-bdo-cap-usage.de9db615.png";